import { style } from 'typestyle'

export const folderListDiv = style({
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1rem',
})
